export default "__VITE_ASSET__V79pyCHC__"